<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <pb-body-base :busy="busy">
        <template v-slot:default="props">
            <pb-body >
                <template slot="title">
                    <b-container>
                    <b-row class="mt-7 mb-4">
                        <b-col class="text-left">
                            <h3>SUSTAINABILITY</h3>
                            <hr class="left"/>
                        </b-col>
                    </b-row>
                    </b-container>
                </template>
                <template slot="body">
                    <b-container>
                        <b-row>
                            <b-col class="p-0 m-0">
                                <b-row>
                                    <b-col class="mt-4" :md="item.width" v-bind:key="index" v-for="(item, index) in layout">
                                        <h2 v-if="item.template === 'Headline'">{{item.headline}}</h2>
                                        <div class="about-box"
                                             v-else-if="item.template === ' Vertikal Bild und Text'">
                                            <b-row no-gutters >
                                                <b-col>
                                                    <img :src="fileResourceUrl(item.image)"
                                                         :alt="item.image"/>
                                                </b-col>
                                            </b-row>
                                            <b-row no-gutters>
                                                <b-col v-html="item.text" class="text-center p-4">
                                                </b-col>
                                            </b-row>
                                        </div>
                                        <div class="about-box"
                                             v-else-if="item.template === 'image_text_horizontally'">
                                            <b-row no-gutters >
                                                <b-col>
                                                    <img :src="fileResourceUrl(item.image)"
                                                         :alt="item.image"/>
                                                </b-col>
                                                <b-col v-html="item.text" class="text-center p-4">
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>


<script>

    import ContentAPI from "@shared/_api/cms/content";

    export default {
        name: 'sustainability_v2',

        mounted() {
            this.busy = true;
            ContentAPI.fetchListByName("sustainability").then(result => {
                this.layout = result.map(item => {
                    return {
                        width: parseInt(item.width.value),
                        image: item.image.value,
                        headline: item.headline.value,
                        text: item.text.value,
                        template: item.template.value,
                        order: parseInt(item.order.value)
                    }
                });

                this.layout = this.$_.orderBy(this.layout, ['order'],['asc']);
            }).finally(() => {
                this.busy = false
            });
        },
        data: function () {
            return {
                breadcrumbs: [{
                    text: "Sustainability",
                    href: '/sustainability'
                }],
                layout: [],
                bannerImage: "",
                busy: false

            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .vue-grid-item.no-touch {
        touch-action: auto;
    }

    .vue-grid-item {
        padding: 10px;


    }

    .about-box {
        height: 100%;
        width: 100%;
        background: #F1F1F1;

        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }

</style>
